export default __webpack_public_path__ + "static/media/nosotros.1ef4cfd6.svg";